import React from 'react'

const InstagramIcon = (props) => {
  return (
    <svg className="instagram-icon" viewBox="0 0 22 22">
      <path d="M16,22H6a6,6,0,0,1-6-6V6A6,6,0,0,1,6,0H16a6,6,0,0,1,6,6V16A6,6,0,0,1,16,22ZM6,2A4,4,0,0,0,2,6V16a4,4,0,0,0,4,4H16a4,4,0,0,0,4-4V6a4,4,0,0,0-4-4Z"/>
      <path d="M11,16a5,5,0,0,1-.72-10,5.17,5.17,0,0,1,1.47,0A5,5,0,0,1,16,10.22h0a5,5,0,0,1-4.21,5.68A4.74,4.74,0,0,1,11,16Zm0-8L10.6,8a3,3,0,0,0,.88,5.93,2.9,2.9,0,0,0,2-1.18A2.94,2.94,0,0,0,14,10.52h0A3,3,0,0,0,11.48,8,3.15,3.15,0,0,0,11,8Z"/>
      <path d="M16.5,6.5a1.05,1.05,0,0,1-.71-.29,1.15,1.15,0,0,1-.21-.33.84.84,0,0,1-.08-.38,1,1,0,1,1,2,0,1,1,0,0,1-.08.38,1.15,1.15,0,0,1-.21.33A1.05,1.05,0,0,1,16.5,6.5Z"/>
    </svg>
  )
}

export default InstagramIcon


// WEBPACK FOOTER //
// ./src/assets/icons/instagram-icon.js